import React, { memo } from 'react';

import styles from '@/components/BottomNavigation/BottomNavigation.module.scss';
import BottomNavigationSlot from '@/components/BottomNavigation/BottomNavigationSlot';
import {
  BottomNavigationItem,
  BottomNavigationProps,
} from '@/components/BottomNavigation/types';
import { ShouldPreventDefaultForClick } from '@/components/LaunchStrategiesProvider/utils';

import { createRel } from './ItemGame';

interface ItemCommandProps {
  item: BottomNavigationItem;
  index: number;
  onCommandItemClick: BottomNavigationProps['onBottomNavigationCommandClick'];
  setActiveCommandTitle: (title: string) => void;
}

const ItemCommand: React.FC<ItemCommandProps> = memo(
  ({ item, index, onCommandItemClick, setActiveCommandTitle }) => {
    const preventDefaultForClick = ShouldPreventDefaultForClick();

    const handleCommandItemClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (preventDefaultForClick) e.preventDefault();
      onCommandItemClick &&
        onCommandItemClick({
          itemTitle: item.title,
          command: item.command,
        });
      setActiveCommandTitle(item.title);
    };

    return (
      <div className={styles.slot} key={index} data-testid="slot">
        <a /* eslint jsx-a11y/anchor-is-valid: 0 */
          className={styles.link}
          rel={createRel(item)}
          onClick={handleCommandItemClick}
        >
          <BottomNavigationSlot item={item} />
        </a>
      </div>
    );
  }
);

export default ItemCommand;
